import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-gray-200 p-6">
            <div className="bg-white bg-opacity-80 backdrop-blur-md p-12 rounded-3xl shadow-xl max-w-md text-center">
                <img 
                    src="https://cdn.iverse.iquanta.in/questionBank/c66a5c10-96b0-4009-9bbd-c97f46071366.png" 
                    alt="404 Not Found" 
                    className="w-52 mx-auto mb-6 opacity-80"
                />
                {/* <h1 className="text-5xl font-extrabold text-red-500 drop-shadow-md">404</h1> */}
                <h2 className="text-2xl font-extrabold text-red-500 mt-2 drop-shadow-md">Oops! Page Not Found</h2>
                <p className="text-lg text-gray-600 mt-3">
                    Sorry, the page you are looking for does not exist or has been moved.
                </p>
                <Button
                    variant="contained"
                    color="primary"
                    className="mt-6 px-6 py-3 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                    onClick={() => navigate("/main/exam")}
                >
                    Go Back
                </Button>
            </div>
        </div>
    );
};

export default NotFound;
